// extracted by mini-css-extract-plugin
export default {"card":"cardvalues_card__MyNfV","logo":"cardvalues_logo__SeRub","filter":"cardvalues_filter__4p1-1","title":"cardvalues_title__hT93s","blue":"cardvalues_blue__gvpah"};